<div class="page page--form historico-lote">
    <button type="button" class="back-link mb-2" data-testid="volver" (click)="volver()"><i class="bi bi-arrow-left" aria-hidden="true"></i>Volver</button>
    <app-page-header titulo="Asignar a varios ejercicios" icono="bi-collection" seccion="historico"
        descripcion="Registra un mismo cargo de una persona en una asociación para varios ejercicios, con vista previa antes de escribir. Solo se crean relaciones nuevas: no se borra ni se sustituye nada."></app-page-header>

    @if (!puedeEscribir) {
        <div class="alert alert-warning" role="alert" data-testid="sin-permiso">No tienes permiso para modificar el histórico. Esta operación exige el permiso «Dar de alta y de baja registros del histórico».</div>
    }
    @if (errorCatalogos) {
        <div class="alert alert-danger d-flex justify-content-between align-items-center" role="alert" data-testid="error-catalogos">
            <span>{{ errorCatalogos }}</span>
            <button type="button" class="btn btn-outline-danger btn-sm" data-testid="reintentar-catalogos" (click)="cargarCatalogos()">Reintentar</button>
        </div>
    }

    <div class="panel">
    <fieldset class="fieldset-plain" [disabled]="!puedeEscribir || ocupado" aria-labelledby="lote-paso1">
        <legend class="step-title" id="lote-paso1"><span class="step-number" aria-hidden="true">1</span>Datos de la asignación</legend>
        <div class="form-grid">
            <div>
                <label class="form-label" for="lote-asociado">Asociado</label>
                @if (asociado) {
                    <div class="form-control selected-chip" data-testid="asociado-seleccionado">
                        <span>{{ nombreCompleto(asociado) }}</span>
                        <button type="button" class="btn btn-link btn-sm p-0" aria-label="Cambiar asociado" data-testid="asociado-cambiar" (click)="cambiarAsociado()">Cambiar</button>
                    </div>
                } @else if (recuperandoAsociado) {
                    <div class="form-control text-muted small" data-testid="asociado-recuperando">Cargando el asociado…</div>
                } @else {
                    <app-asociado-buscador inputId="lote-asociado" [control]="texto" [minCaracteres]="3" placeholder="Nombre, apellidos o DNI/NIF" [conservarSeleccion]="false" (elegido)="fijarAsociado($event)"></app-asociado-buscador>
                    @if (errorAsociado) { <div class="field-error" role="alert" data-testid="asociado-error">{{ errorAsociado }}</div> }
                }
            </div>
            <app-selector-busqueda inputId="lote-asociacion" etiqueta="Asociación" placeholder="Escribe el nombre de la asociación"
                [opciones]="asociaciones" [cargando]="cargandoCatalogos" [grupos]="GRUPOS_ASOCIACION" etiquetaGrupo="Tipo de asociación"
                [valor]="asociacionId" [deshabilitado]="!puedeEscribir || ocupado" (elegido)="elegirAsociacion($event)"></app-selector-busqueda>
            <app-selector-busqueda inputId="lote-cargo" etiqueta="Cargo" placeholder="Escribe el nombre del cargo"
                [opciones]="cargos" [cargando]="cargandoCatalogos" [grupos]="GRUPOS_CARGO" etiquetaGrupo="Adultos o infantiles"
                [valor]="cargoId" [deshabilitado]="!puedeEscribir || ocupado" (elegido)="elegirCargo($event)"></app-selector-busqueda>
            <app-selector-ejercicios class="span-all" [ejercicios]="ejercicios" [seleccion]="seleccion" [cargando]="cargandoCatalogos"
                [deshabilitado]="!puedeEscribir || ocupado" (seleccionChange)="cambiarEjercicios($event)"></app-selector-ejercicios>
        </div>
        <div class="form-actions mt-3 align-items-center">
            <button type="button" class="btn btn-primary" data-testid="previsualizar" [disabled]="!puedePrevisualizar" (click)="previsualizar()">
                @if (previsualizando) { Calculando… } @else { <i class="bi bi-eye" aria-hidden="true"></i>Vista previa }
            </button>
            @if (!entradaCompleta) { <span class="small text-muted" data-testid="falta-datos">Elige asociado, asociación, cargo y al menos un ejercicio.</span> }
        </div>
    </fieldset>
    </div>

    @if (previaInvalidada && !plan && !resultado) {
        <div class="alert alert-info py-2" role="status" data-testid="previa-invalidada">Has cambiado los datos: la vista previa anterior ya no es válida. Genérala de nuevo para poder confirmar.</div>
    }
    @if (error) {
        <div class="alert alert-danger" role="alert" data-testid="error">{{ error }}</div>
    }

    @if (plan) {
        <section class="panel panel--warning" aria-labelledby="titulo-previa" data-testid="vista-previa">
            <h2 id="titulo-previa" class="step-title"><span class="step-number" aria-hidden="true">2</span>Vista previa · revisa antes de confirmar</h2>
            <p class="plan-id">
                <strong>{{ plan.cargo.nombre }}</strong> · {{ plan.asociado.nombre }} {{ plan.asociado.apellidos }} · {{ plan.asociacion.nombre }}
            </p>
            @for (aviso of plan.avisos; track aviso) {
                <div class="alert alert-warning py-2 mb-2" role="alert" data-testid="aviso">{{ aviso }}</div>
            }
            <div class="table-wrap table-bordered-wrap" tabindex="0" role="region" aria-label="Vista previa por ejercicio (desplazable)">
                <table class="table table-sm align-middle table-stack">
                    <thead><tr><th scope="col">Ejercicio</th><th scope="col">Resultado</th><th scope="col">Movimiento</th><th scope="col">Detalle</th></tr></thead>
                    <tbody>
                        @for (f of filas(plan); track f.idEjercicio) {
                            <tr data-testid="fila-previa">
                                <td data-label="Ejercicio">{{ f.anyoEjercicio }}@if (f.ejercicioVigente) { <span class="badge text-bg-primary ms-1">vigente</span> }</td>
                                <td data-label="Resultado"><span class="badge" [ngClass]="ETIQUETA[f.estado].clase">{{ ETIQUETA[f.estado].texto }}</span></td>
                                <td data-label="Movimiento" class="small" data-testid="movimiento">{{ f.tipoMovimiento === 'alta' ? 'Alta' : f.tipoMovimiento === 'cambio' ? 'Cambio de cargo' : '' }}</td>
                                <td data-label="Detalle" class="small">{{ f.mensaje }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            <p class="summary-callout" data-testid="resumen-previa">
                Se crearán <strong>{{ plan.resumen.crear }}</strong> · se actualizarán <strong>{{ plan.resumen.actualizar ?? 0 }}</strong> ({{ plan.resumen.altas }} alta(s) · {{ plan.resumen.cambios }} cambio(s) de cargo en total) · ya existentes {{ plan.resumen.existentes }} · con conflicto {{ plan.resumen.conflictos }}
            </p>
            @if (((plan.resumen.crear ?? 0) + (plan.resumen.actualizar ?? 0)) === 0) {
                <p class="small text-muted mb-0" data-testid="nada-que-crear">No hay relaciones que crear ni actualizar con esta selección.</p>
            }
            <div class="form-actions mt-2">
                <button type="button" class="btn btn-success" data-testid="confirmar" [disabled]="!puedeConfirmar" (click)="confirmar()">
                    @if (aplicando) { Aplicando… } @else { <i class="bi bi-check2-circle" aria-hidden="true"></i>Confirmar y aplicar }
                </button>
            </div>
        </section>
    }

    @if (resultado) {
        <section class="panel panel--success" aria-labelledby="titulo-resultado" data-testid="resultado">
            <h2 id="titulo-resultado" class="step-title"><span class="step-number step-number--ok" aria-hidden="true"><i class="bi bi-check-lg"></i></span>Resultado</h2>
            <p class="summary-callout" data-testid="resumen-resultado">
                Creadas <strong>{{ resultado.resumen.creadas }}</strong> · actualizadas <strong>{{ resultado.resumen.actualizadas ?? 0 }}</strong> ({{ resultado.resumen.altas }} alta(s) · {{ resultado.resumen.cambios }} cambio(s) de cargo en total) · ya existentes {{ resultado.resumen.existentes }} · con conflicto {{ resultado.resumen.conflictos }}
            </p>
            <div class="table-wrap table-bordered-wrap" tabindex="0" role="region" aria-label="Resultado por ejercicio (desplazable)">
                <table class="table table-sm align-middle table-stack">
                    <thead><tr><th scope="col">Ejercicio</th><th scope="col">Resultado</th><th scope="col">Movimiento</th><th scope="col">Detalle</th></tr></thead>
                    <tbody>
                        @for (f of filas(resultado); track f.idEjercicio) {
                            <tr data-testid="fila-resultado">
                                <td data-label="Ejercicio">{{ f.anyoEjercicio }}</td>
                                <td data-label="Resultado"><span class="badge" [ngClass]="ETIQUETA[f.estado].clase">{{ ETIQUETA[f.estado].texto }}</span></td>
                                <td data-label="Movimiento" class="small">{{ f.tipoMovimiento === 'alta' ? 'Alta' : f.tipoMovimiento === 'cambio' ? 'Cambio de cargo' : '' }}</td>
                                <td data-label="Detalle" class="small">{{ f.mensaje }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            <div class="form-actions mt-3">
                <button type="button" class="btn btn-outline-primary" data-testid="ver-historico" (click)="verHistorico()"><i class="bi bi-archive" aria-hidden="true"></i>Ver el histórico de la persona</button>
                <button type="button" class="btn btn-outline-secondary" data-testid="nueva" (click)="nueva()"><i class="bi bi-plus-lg" aria-hidden="true"></i>Nueva asignación</button>
            </div>
        </section>
    }
</div>
